(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/communication-settings/personalization-settings-panel/personalization-settings-service.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/communication-settings/personalization-settings-panel/personalization-settings-service.js');
'use strict';

const jupiter = svs.core.jupiter;
const svsFetch = svs.core.svsFetch.create();

const getCustomersSettingsAsync = async () => {
  svs.myProfile.logger.debug('PersonalizationSettingsService:getCustomersSettingsAsync start...');
  const useOldJupiterApi = !svs.core.detect.feature('ft-elza-my-profile');
  if (useOldJupiterApi) {
    try {
      var _reply$response, _reply$response2;
      const reply = await jupiter.callAsync({
        method: 'GET',
        path: '/player/1/settings'
      });
      svs.myProfile.logger.debug('PersonalizationSettingsService:getCustomersSettingsAsync response from jupiter:', reply.response);
      return {
        error: (_reply$response = reply.response) === null || _reply$response === void 0 ? void 0 : _reply$response.error,
        settings: (_reply$response2 = reply.response) === null || _reply$response2 === void 0 ? void 0 : _reply$response2.settings
      };
    } catch (err) {
      svs.myProfile.logger.debug('PersonalizationSettingsService:getCustomersSettingsAsync error...');
      svs.myProfile.logger.warn(err);
      return {
        error: err,
        settings: {}
      };
    }
  }
  try {
    const response = await svsFetch('/preferences/v1/customers/me', {
      method: 'GET'
    });
    if (!response.ok) {
      let errorDetail = 'Error fetching personalization settings';
      try {
        const errorResult = await response.json();
        errorDetail = errorResult.title || errorResult.detail || errorDetail;
        svs.myProfile.logger.warn("Error fetching personalization settings (Elza): ".concat(errorResult.type), errorDetail);
      } catch (_unused) {
        svs.myProfile.logger.error('Error fetching personalization settings (Elza)', response.status);
      }
      return {
        error: errorDetail,
        settings: {}
      };
    }
    const result = await response.json();
    svs.myProfile.logger.debug('PersonalizationSettingsService:getCustomersSettingsAsync response from elza:', result);
    return {
      error: null,
      settings: (result === null || result === void 0 ? void 0 : result.data) || {}
    };
  } catch (err) {
    svs.myProfile.logger.debug('PersonalizationSettingsService:getCustomersSettingsAsync error from elza...');
    svs.myProfile.logger.warn(err);
    return {
      error: err,
      settings: {}
    };
  }
};

const putCustomersSettingsAsync = async settings => {
  const useOldJupiterApi = !svs.core.detect.feature('ft-elza-my-profile');
  if (useOldJupiterApi) {
    try {
      const data = {
        settings: [settings]
      };
      const _await$jupiter$callAs = await jupiter.callAsync({
          method: 'PUT',
          path: '/player/1/settings',
          data
        }),
        response = _await$jupiter$callAs.response,
        status = _await$jupiter$callAs.status;
      if (status !== 'success') {
        svs.myProfile.logger.warn('PersonalizationSettingsService:setCustomersSettingsAsync error response from jupiter:', response.error);
        return {
          status,
          error: response.error
        };
      }
      svs.myProfile.logger.debug('PersonalizationSettingsService:setCustomersSettingsAsync response from jupiter:', response);
      return {
        status,
        error: response.error
      };
    } catch (err) {
      svs.myProfile.logger.warn(err);
      return {
        status: 'error',
        error: err
      };
    }
  }
  try {
    const preferences = {
      [settings.key]: settings.value
    };
    const response = await svsFetch('/preferences/v1/customers/me', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(preferences)
    });
    if (!response.ok) {
      let errorDetail = 'Error setting personalization preferences';
      try {
        const body = await response.json();
        errorDetail = (body === null || body === void 0 ? void 0 : body.title) || (body === null || body === void 0 ? void 0 : body.detail) || errorDetail;
        svs.myProfile.logger.warn("Error response from PUT personalization preferences (Elza): ".concat(body === null || body === void 0 ? void 0 : body.type), response.status, errorDetail);
      } catch (_unused2) {
        svs.myProfile.logger.error('Error setting personalization preferences (Elza)', response.status);
      }
      return {
        status: 'error',
        error: errorDetail
      };
    }
    svs.myProfile.logger.debug('PersonalizationSettingsService:setCustomersSettingsAsync success response from elza');
    return {
      status: 'success',
      error: null
    };
  } catch (err) {
    svs.myProfile.logger.warn('PersonalizationSettingsService:setCustomersSettingsAsync error from elza:', err);
    return {
      status: 'error',
      error: err
    };
  }
};
svs.myProfile.react.pages.communicationSettings.personalizationSettings.personalizationSettingsService = {
  putCustomersSettingsAsync,
  getCustomersSettingsAsync
};

 })(window);